import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'trackingNumber' })
export class TrackingNumberPipe implements PipeTransform {
  private upsRegex = /\b(1Z ?[0-9A-Z]{3} ?[0-9A-Z]{3} ?[0-9A-Z]{2} ?[0-9A-Z]{4} ?[0-9A-Z]{3} ?[0-9A-Z]|[\dT]\d\d\d ?\d\d\d\d ?\d\d\d)\b/i;
  private fedexRegex = /(\b96\d{20}\b)|(\b\d{15}\b)|(\b\d{12}\b)/;

  transform(trackingNumber: string): string {
    if (this.upsRegex.test(trackingNumber)) {
      return 'https://www.ups.com/track?tracknum=' + trackingNumber;
    }

    if (this.fedexRegex.test(trackingNumber) || this.fedexRegex.test(trackingNumber.replace(/^0+/, ''))) {
      return 'https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=' + trackingNumber;
    }

    return null;
  }
}
